import { Component, forwardRef, Injector, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';

@Component({
  selector: 'app-r-con-string',
  templateUrl: './r-con-string.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RConStringComponent),
      multi: true
    }
  ]
})
export class RConStringComponent extends RenderComponentBase {
  static KEY = 'r-d-con-string';

  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {
    if (!config.effective) {
      config.effective = [];
    }
  }
}
